import React, { useRef, useState } from "react";
import { Button, Checkbox } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import { StandardDrawerFooter, StandardDrawerHeader } from "./StandardDrawer";
import { getDoc, doc } from "firebase/firestore";
import { useEffect } from "react";
import { db } from "../../firebase";
import ReactToPrint from "react-to-print";

function ViewContinuatedTherapySupport(props) {
  const [signaturePic, setSignaturePic] = useState(null);

  const printRef = useRef();
  const [, setText0] = useState("");
  const [text1, setText1] = useState("");
  const [text2, setText2] = useState("");
  const [text3, setText3] = useState("");
  const [text4, setText4] = useState("");
  const [text5, setText5] = useState("");
  const [text6, setText6] = useState("");
  const [text7, setText7] = useState("");
  const [textExtra8, setTextExtra8] = useState("");
  const [textExtra9, setTextExtra9] = useState("");
  const [textExtra10, setTextExtra10] = useState("");
  const [text8, setText8] = useState("");
  const [text9, setText9] = useState("");
  const [text10, setText10] = useState("");
  const [text11, setText11] = useState("");
  const [text12, setText12] = useState("");
  const [text13, setText13] = useState("");
  const [text14, setText14] = useState("");
  const [text15, setText15] = useState("");
  const [text16, setText16] = useState("");
  const [sessionCount, setSessionCount] = useState("");

  function formatDate(timestamp) {
    const date = timestamp.toDate();
    const day = date.getDate().toString().padStart(2, "0");
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const timeZone = date
      .toLocaleString("en", { timeZoneName: "short" })
      .split(" ")
      .pop();

    return `${day} ${month} ${year} ${hours}:${minutes} ${timeZone}`;
  }

  const fetchSignatureUrl = async () => {
    const docRef = doc(db, "ContinuatedTherapySupport", props.clientId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      const signatureUrl = data.signatureURL;
      setSignaturePic(signatureUrl);
      setText0(data.text0);
      setText1(data.text1);
      setText2(data.text2);
      setText3(data.text3);
      setText4(data.text4);
      setText5(data.text5);
      setText6(data.text6);
      setText7(data.text7);
      setTextExtra8(data.textExtra8);
      setTextExtra9(data.textExtra9);
      setTextExtra10(data.textExtra10);
      setText8(data.text8);
      setText9(data.text9);
      setText10(data.text10);
      setText11(data.text11);
      setText12(data.text12);
      setText13(data.text13);
      setText14(data.text14);
      setText15(data.text15);
      setText16(data.text16);
      setSessionCount(data.sessionCount);
    } else {
      console.log("No such document (signaturePic ref)!");
    }
  };

  useEffect(() => {
    fetchSignatureUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <style>
        {`
          @media print {
            #printableContent {
              height: auto !important;
              overflow-y: visible !important;
            }
          }
        `}
      </style>

      <div className="standard-drawer-form-wrapper cts-drawer-form">
        <StandardDrawerHeader
          eyebrow="CLINICAL FORM"
          title="Continuing Therapeutic Support (CTS) Form"
          subtitle={`${props.firstName || ""} ${props.lastName || ""}`.trim()}
          onClose={props.closemodal}
        />

        <div
          id="printableContent"
          style={{
            width: "100%",
            flex: 1,
            minHeight: 0,
            overflowY: "scroll",
            // overflowX: "hidden",
          }}
          ref={printRef}
          // style={{ marginTop: "60px", height: "500px", overflowY: "scroll" }}
          // style={{ marginTop: "60px", height: "auto", overflowY: "scroll" }}
        >
          <div
            className="client-name-container"
            style={{ paddingLeft: "25px" }}
          >
            Continuated Therapy Support form for: {props.firstName}{" "}
            {props.lastName}
          </div>
          <div
            className="session-count"
            style={{ paddingTop: "20px", paddingLeft: "50px" }}
          >
            Number of Sessions in Package:{" "}
            <span style={{ fontWeight: "bold", color: "#1565C0" }}>
              {sessionCount}
            </span>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text1}</div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text2}</div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text3}</div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text4}</div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text5}</div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text6}</div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text7}</div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{textExtra8}</div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{textExtra9}</div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{textExtra10}</div>
          </div>

          <div className="SubTitleBold">Refund Policy:</div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text8}</div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text9}</div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text10}</div>{" "}
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text11}</div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text12}</div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text13}</div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text14}</div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text15}</div>
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={true} />
            <div className="block-text-check">{text16}</div>
          </div>

          <div className="signature-date-container">
            <div className="text-block-2">
              Timestamp signature :{" "}
              {formatDate(props.ContinuatedTherapySupportDateSigned)}{" "}
            </div>
            <div className="signature-title">
              Client signature (
              <span style={{ fontWeight: "bold" }}>
                {props.firstName} {props.lastName}
              </span>
              ):
            </div>
            <img
              alt="Signature"
              className="signature-pic-roi"
              src={signaturePic}
            />
          </div>
        </div>
        <StandardDrawerFooter className="cts-drawer-footer">
          <>
            <Button
              variant="contained"
              style={{ backgroundColor: "white", color: "black" }}
              onClick={props.closemodal}
            >
              Cancel
            </Button>

            <ReactToPrint
              trigger={() => (
                <Button variant="contained" style={{ marginLeft: "20px" }}>
                  Print
                </Button>
              )}
              content={() => printRef.current}
              onAfterPrint={props.closemodal}
            />
          </>
        </StandardDrawerFooter>
      </div>
    </>
  );
}

export default ViewContinuatedTherapySupport;
